import { Container, Slide } from './styles'
import { useKeenSlider } from 'keen-slider/react'
import { useWindowSize } from 'react-use'
import { IGeneral, IProgress } from '../DashboardContent/types'
import { useMemo } from 'react'

const slides = [
  { id: 1, value: '30%', label: 'Progresso' },
  { id: 2, value: '12/36', label: 'Módulos' },
  { id: 3, value: '20', label: 'Horas estudadas' },
  { id: 4, value: '25', label: 'Dias estudados' },
]

interface IDashboardCarouselProps {
  general: IGeneral
  progress: IProgress
}

const DashboardCarousel = (props: IDashboardCarouselProps) => {
  const { width } = useWindowSize()

  const slideWidth = 312

  const perView = Math.min(Math.max(width / slideWidth, 1), slides.length)

  const [ref] = useKeenSlider({
    slides: { spacing: 8, perView },
  })
  const formattedHours = useMemo(() => {
    const totalHours = Math.round(props.general.totalHours * 100) / 100

    const hours = Math.floor(totalHours)
    const minutes = Math.round((totalHours - hours) * 60)

    const minutesString = minutes > 0 ? `${minutes}m` : ''

    const timeString = `${hours}h ${minutesString}`

    return timeString
  }, [props.general.totalHours])

  return (
    <Container ref={ref} className="keen-slider" style={{ overflow: 'visible' }}>
      <div className="keen-slider__slide">
        <Slide>
          <p className="value">{props.progress.courseProgress}%</p>
          <p className="label">Progresso</p>
        </Slide>
      </div>
      <div className="keen-slider__slide">
        <Slide>
          <p className="value">
            {props.progress.totalModulesCompleted}/{props.progress.totalModules}
          </p>
          <p className="label">Módulos</p>
        </Slide>
      </div>
      <div className="keen-slider__slide">
        <Slide>
          <p className="value">{formattedHours}</p>
          <p className="label">Horas Estudadas</p>
        </Slide>
      </div>
      <div className="keen-slider__slide">
        <Slide>
          <p className="value">{props.general.totalDays}</p>
          <p className="label">Dias Estudados</p>
        </Slide>
      </div>
    </Container>
  )
}

export default DashboardCarousel
